// 'history' namespace — keys are prefixed 'history.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'history.subtitle': 'Все ваши попытки — черновики и проверенные работы',
  'history.searchPlaceholder': 'Поиск по названию и тексту, например «καλημέρα»',
  'history.clearSearch': 'Очистить поиск',
  'history.filterMode': 'Режим',
  'history.filterState': 'Статус',
  'history.allModes': 'Все режимы',
  'history.submitted': 'Отправленные',
  'history.drafts': 'Черновики',
  'history.edited': 'изменено',
  'history.submittedAt': 'отправлено',
  'history.page.one': 'страница',
  'history.page.few': 'страницы',
  'history.page.many': 'страниц',
  'history.accuracy': 'точность',
  'history.practiceScore': 'учебная оценка',
  'history.shared': 'у преподавателя',
  'history.sharedWith': 'Открыто преподавателям: {n}',
  'history.noMatches': 'Ничего не нашлось',
  'history.noMatchesText':
    'Нет попыток, где встречается «{q}». Попробуйте другое слово или сбросьте фильтры.',
  'history.resetFilters': 'Сбросить фильтры',
  'history.emptyTitle': 'История пока пуста',
  'history.emptyText': 'Здесь будут все ваши попытки: рукопись, подтверждённый текст и разбор ошибок.',
  'history.startFirst': 'Начать с копирования',
};
const en: Record<string, string> = {
  'history.subtitle': 'All your attempts — drafts and checked work',
  'history.searchPlaceholder': 'Search titles and text, e.g. “καλημέρα”',
  'history.clearSearch': 'Clear search',
  'history.filterMode': 'Mode',
  'history.filterState': 'Status',
  'history.allModes': 'All modes',
  'history.submitted': 'Submitted',
  'history.drafts': 'Drafts',
  'history.edited': 'edited',
  'history.submittedAt': 'submitted',
  'history.page.one': 'page',
  'history.page.few': 'pages',
  'history.page.many': 'pages',
  'history.accuracy': 'accuracy',
  'history.practiceScore': 'practice score',
  'history.shared': 'shared',
  'history.sharedWith': 'Shared with {n} teacher(s)',
  'history.noMatches': 'Nothing found',
  'history.noMatchesText': 'No attempts contain “{q}”. Try another word or reset the filters.',
  'history.resetFilters': 'Reset filters',
  'history.emptyTitle': 'No history yet',
  'history.emptyText': 'All your attempts will appear here: handwriting, confirmed text and feedback.',
  'history.startFirst': 'Start with copying',
};
export default { ru, en };
